import { c as _c } from "react/compiler-runtime";
import RealEstateDetail from "./RealEstateDetail/RealEstateDetail";
type Props = {
  realEstateId: string | undefined;
  inDialog?: boolean;
};

// Demand listings render through the same detail as supply — only the images
// card (→ avatar/bio) and the location (→ area polygon) differ, handled inside.
export function RealEstateDetailWrapper(t0) {
  const $ = _c(3);
  const {
    realEstateId,
    inDialog
  } = t0;
  let t1;
  if ($[0] !== inDialog || $[1] !== realEstateId) {
    t1 = <RealEstateDetail realEstateId={realEstateId} inDialog={inDialog} data-sentry-element="RealEstateDetail" data-sentry-component="RealEstateDetailWrapper" data-sentry-source-file="RealEstateDetailWrapper.tsx" />;
    $[0] = inDialog;
    $[1] = realEstateId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}